import HomePageLayout from 'global/HomePageLayout';
import Text from '@deprecated-ui/common/Text';
import color from '@deprecated-ui/_style/color';
import Link from 'next/link';
import Image from 'global/Image';
import sanitizer from 'string-sanitizer';
import { useRouter } from 'next/router';
import GroupAvatar from './GroupAvatar';
import {
  GuestInvitationContainer,
  GuestInvitationWrapper,
  GuestJoinGroupButton,
} from './styled';
import {
  DATA_COMPONENT_GROUP_INVITATION_GUEST,
  DATA_COMPONENT_GROUP_INVITATION_GUEST_NOT_FOUND,
} from './__tests__/constant';

const LS_REDIRECT_AFTER_LOGIN_KEY = 'redirectAfterLogin';

export interface GuestInvitationProps {
  data: any;
}

function GuestInvitation({ data }: GuestInvitationProps) {
  const router = useRouter();

  const handleClickJoin = () => {
    localStorage.setItem(LS_REDIRECT_AFTER_LOGIN_KEY, router.asPath);
  };

  if (data.isDataFound) {
    const { info } = data;

    const { avatar_url: avatarUrl, shortened_name: shortName } = info;
    const name = sanitizer.sanitize.keepSpace(info?.name);

    return (
      <HomePageLayout hideStartInvesting>
        <GuestInvitationWrapper data-cy={DATA_COMPONENT_GROUP_INVITATION_GUEST}>
          <GuestInvitationContainer>
            <GroupAvatar name={name} shortName={shortName} src={avatarUrl} />
            <Text size="16px" family="bold" height="135%" align="center">
              {name}
            </Text>
            <Text size="11px" color={color.highgray} align="center">
              Stockbit Group Invite
            </Text>
            <Link href="/login" passHref>
              <GuestJoinGroupButton onClick={handleClickJoin}>
                Join Group
              </GuestJoinGroupButton>
            </Link>
          </GuestInvitationContainer>
        </GuestInvitationWrapper>
      </HomePageLayout>
    );
  }

  return (
    <HomePageLayout hideStartInvesting>
      <GuestInvitationWrapper
        data-cy={DATA_COMPONENT_GROUP_INVITATION_GUEST_NOT_FOUND}
      >
        <GuestInvitationContainer>
          <Image
            src="/icon/chat-group-avatar-not-found.svg"
            alt="Avatar not found"
          />
          {/* @ts-expect-error */}
          <Text size="11px" color={color.highgray} align="center" mt="15px">
            Stockbit Group Invite
          </Text>
          <Link href="/login" passHref>
            <GuestJoinGroupButton onClick={handleClickJoin}>
              Join Group
            </GuestJoinGroupButton>
          </Link>
        </GuestInvitationContainer>
      </GuestInvitationWrapper>
    </HomePageLayout>
  );
}

export default GuestInvitation;
